import {
  EXTERNAL_ACCOUNT_RESET,
  EXTERNAL_ACCOUNT_SET_ACCOUNT,
  EXTERNAL_ACCOUNT_SET_TIMED_OUT,
  EXTERNAL_ACCOUNT_SET_TIMING_OUT,
} from "src/redux/actions";

export interface ExternalAccountStateI {
  account?: { companyName: string; companyID: string };
  isTimingOut: boolean;
  isTimedOut: boolean;
}

const initialState = {
  account: null,
  isTimingOut: false,
  isTimedOut: false,
};

const externalAccount = (
  state: ExternalAccountStateI = initialState,
  action
): ExternalAccountStateI => {
  switch (action.type) {
    case EXTERNAL_ACCOUNT_SET_ACCOUNT:
      return {
        ...state,
        account: action.account,
      };
    case EXTERNAL_ACCOUNT_SET_TIMING_OUT:
      return {
        ...state,
        isTimingOut: action.payload,
      };
    case EXTERNAL_ACCOUNT_SET_TIMED_OUT:
      return {
        ...state,
        isTimedOut: action.payload,
      };
    case EXTERNAL_ACCOUNT_RESET:
      return initialState;
    default:
      return state;
  }
};

export default externalAccount;
